'use client';

import { useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';

const SearchBar = () => {
  const router = useRouter();
  const pathname = usePathname();
  const [searchQuery, setSearchQuery] = useState('');

  // 从路径中获取当前语言
  const getCurrentLang = () => {
    const pathParts = pathname.split('/');
    // 支持的语言代码列表
    const supportedLangs = ['en', 'ja', 'es', 'ko', 'th', 'ru', 'vi', 'kk', 'id', 'de'];
    // 检查第一段是否是支持的语言代码
    return supportedLangs.includes(pathParts[1]) ? pathParts[1] : 'en';
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const currentLang = getCurrentLang();
      router.push(`/${currentLang}/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <div className="relative">
      <form onSubmit={handleSearch} className="search-container flex items-center">
        <div className="relative flex-grow">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-64 px-4 py-2 pl-10 pr-8 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="Search games..."
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 p-2 text-gray-400 hover:text-indigo-500"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 512 512">
              <path d="M508.874,478.708L360.142,329.976c28.21-34.827,45.191-79.103,45.191-127.309c0-111.75-90.917-202.667-202.667-202.667
                S0,90.917,0,202.667s90.917,202.667,202.667,202.667c48.206,0,92.482-16.982,127.309-45.191l148.732,148.732
                c4.167,4.165,10.919,4.165,15.086,0l15.081-15.082C513.04,489.627,513.04,482.873,508.874,478.708z M202.667,362.667
                c-88.229,0-160-71.771-160-160s71.771-160,160-160s160,71.771,160,160S290.896,362.667,202.667,362.667z" fill="currentColor"/>
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;